import React, { useEffect, useState } from "react";
import Datatable from "core/pagination/datatable";
import { Link } from "react-router-dom";
import { Edit, PlusCircle } from "react-feather";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import Error404 from "MainPages/ErrorPages/error404";
import { useTableSearch } from "core/Operations/useTableSearch";
import { useGetClaimsQuery } from "AppQuries/claim/claim-management";
import TableTop from "Components/UI/TableTop";
import { all_routes } from "Router/all_routes";
import { endOfMonth, format, startOfMonth } from "date-fns";
import { useGetEmployeeQuery } from "AppQuries/employee/employee_list";
import dayjs from "dayjs";
import { DatePicker } from "antd";
import Select from "react-select";
import ReportTools from "Components/UI/ReportTools";
import { hasPermission } from "core/Operations/checkPermission";
import { useFormattedEmployees } from "core/Operations/formattedOption/useFormattedEmployeeOptions";
import { selectUserPermissions } from "core/redux/slice/userPermissionSlice";
import { useGetEmailAlertConfigsQuery } from "AppQuries/setting/email-alert-config";
import Can from "core/Operations/Can";
import { accessCodes } from "core/json/accessCode";
const { RangePicker } = DatePicker;
const disabled7DaysDate = (current, { from }) => {
  if (from) {
    return Math.abs(current.diff(from, "days")) >= 90;
  }
  return false;
};

const EmailAlertList = () => {
  const userData = useSelector(loggedInUser);
  const [employeeCode, setEmployeeCode] = useState(0);
  const [filterDate, setFilterDate] = useState({
    fromDate: format(startOfMonth(new Date(), 1), "yyyy-MM-dd"),
    toDate: format(endOfMonth(new Date(), 1), "yyyy-MM-dd"),
  });
  // const permissions = useSelector(selectUserPermissions) || [];
  const permissions = userData?.permissions;

  const {
    data,
    isLoading,
    isFetching,
    isError,
    error,
    refetch: getData,
  } = useGetEmailAlertConfigsQuery(
    {
      companyCode: userData?.companyCode,
    },
    {
      enabled: !!userData.companyCode,
    }
  );

  const [isFilterVisible, setIsFilterVisible] = useState(false);

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const columns = [
    {
      title: "Alert Frequency",
      dataIndex: "alertFrequency",
      sorter: (a, b) => a.alertFrequency.length - b.alertFrequency.length,
    },

    {
      title: "Alert Channel",
      dataIndex: "alertChannel",
      sorter: (a, b) => a.alertChannel.length - b.alertChannel.length,
    },

    {
      title: "Last Sent Date",
      dataIndex: "lastSentDate",

      render: (text, record) => (
        <>
          {record?.lastSentDate
            ? dayjs(record?.lastSentDate).format("DD-MM-YYYY HH:mm:ss")
            : "-"}
        </>
      ),
    },
    {
      title: "No Of Recipients",
      dataIndex: "noofRecipients",
      render: (text, record) => <>{record?.noofRecipients}</>,
    },

    {
      title: "Status",
      dataIndex: "isActive",
      render: (text, record) => (
        <>
          {text === true && (
            <div className="badges badge-linesuccess">Active</div>
          )}
          {text === false && (
            <div className="badges badge-linedanger">In Active</div>
          )}
        </>
      ),
    },
    {
      // hasPermission(
      //   permissions,
      //   "Claims Processing",
      //   "Manage Claims",
      //   "haveEdit"
      // ) && {
      title: "Action",
      className: "action-table-data",
      render: (text, record) => (
        <div className="edit-delete-action">
          <div className="input-block add-lists"></div>
          {/* {hasPermission(
            userData?.permissions,
            "Claims Processing",
            "Manage Claims",
            "haveEdit"
          ) && ( */}
          <Can
            accessModule={accessCodes.settings}
            accessCode={accessCodes.email_setting}
            accessType="haveEdit"
          >
            <Link
              className="me-3"
              to={`${all_routes.setting}${all_routes.edit_email_alert}/${record.alertConfigId}`}
            >
              <Edit className="feather-edit" />
            </Link>
          </Can>
          {/* )} */}
        </div>
      ),
    },
  ];
  const searchColumns = columns.map((column) => column.dataIndex);
  const { setSearchValue, filteredData } = useTableSearch(data, searchColumns);

  if (isLoading || isFetching) return <LoadingSpinner />;
  if (isError) return <Error404 error={error} />;

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Email Alert Config</h4>
                <h6>Manage your Email Alert</h6>
              </div>
            </div>
            {/* 
            <ReportTools
              columns={columns}
              data={filteredData}
              fileName={`Email Alert list ${filterDate.fromDate} - ${filterDate.toDate}`}
              pdfTheme="striped"
              refresh={getData}
            /> */}
            {/* {hasPermission(
              permissions,
              "Claims Processing",
              "Manage Claims",
              "haveAdd"
            ) && ( */}
            <div className="page-btn">
              <Can
                accessModule={accessCodes.settings}
                accessCode={accessCodes.email_setting}
                accessType="haveAdd"
              >
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip id="add-new-tooltip">Add New Alert</Tooltip>
                  }
                >
                  <Link
                    to={`${all_routes.setting}${all_routes.add_email_alert}`}
                    className="btn btn-added"
                  >
                    <PlusCircle className="me-2" />
                    Add Alert
                  </Link>
                </OverlayTrigger>
              </Can>
            </div>
            {/* )} */}
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="card table-list-card border-0">
                <div className="card-body">
                  <TableTop
                    onSearch={setSearchValue}
                    toggleFilterVisibility={toggleFilterVisibility}
                    isFilterVisible={isFilterVisible}
                    showToggle={false}
                  />
                  <div
                    className={`card${isFilterVisible ? " visible" : ""}`}
                    id="filter_inputs"
                    // style={{ display: isFilterVisible ? "block" : "none" }}
                  ></div>
                  <div className="table-responsive">
                    <Datatable
                      className="table datanew"
                      columns={columns}
                      dataSource={filteredData}
                      rowKey={(record) => record.alertConfigId}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailAlertList;
